import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { authInitialState } from './auth.constant';
import { AuthAction } from './auth.action';

export const authReducer = reducerWithInitialState(authInitialState)
  .case(AuthAction.failed, (state, payload) => {
    return {
      ...state,
      isAuthenticated: false,
      authError: payload.error,
    };
  })
  .case(AuthAction.loginDone, (_state, payload) => {
    const { apiToken, apiTokenParsed, idTokenParsed, excludedScope } = payload;

    return {
      isAuthenticated: true,
      apiToken,
      apiTokenParsed,
      idTokenParsed,
      excludedScope: excludedScope ?? [],
    };
  })
  .case(AuthAction.logout, (state) => {
    return {
      ...state,
      isLoggingOut: true,
    };
  })
  .case(AuthAction.destroy, () => {
    return authInitialState;
  });
